import { Controller, UseFormReturn } from "react-hook-form";
import { roleDepartment } from "../../../../lib/atecos/dto";
import { groupBy } from "../../../../lib/utils";
import Input from "../../../../ui/molecules/input";
import { SelectCustom } from "../../../../ui/molecules/select";
import { AtecosSegment } from "../../../targetList/editTargetListDetails/form/atecos";
import { ComparisonFieldEmployees } from "../../../targetList/editTargetListDetails/form/employees";
import { ComparisonFieldRevenue } from "../../../targetList/editTargetListDetails/form/revenue";
import { NewTargetListFormValues } from "../../../targetList/editTargetListDetails/validation";
import { UserRole } from "../../../users/dto";
import { SelectUser } from "../../../users/select/userSelect";

interface Props {
  form: UseFormReturn<NewTargetListFormValues>;
  commercials: string[];
}

export function Form({ form, commercials }: Props) {
  const departments = form.watch("departments");

  return (
    <div className="flex flex-col gap-6 p-4 h-full max-h-full overflow-auto">
      <div className="flex gap-4">
        <Controller
          name="name"
          control={form.control}
          render={({ field }) => (
            <Input
              {...field}
              value={field.value || ""}
              placeholder="Nome lista target"
              label="Nome del Target"
              supportingText={form.formState.errors.name?.message as string | undefined}
              error={!!form.formState.errors.name}
            />
          )}
        />
        <Controller
          name="departments"
          control={form.control}
          render={({ field }) => (
            <SelectCustom
              isMulti
              placeholder={"Indifferente"}
              options={groupBy(roleDepartment, "department").map((department) => ({
                label: department.key,
                value: department.key,
              }))}
              label="Reparti"
              defaultValue={field.value ?? []}
              onChange={(e) => field.onChange(e)}
            />
          )}
        />
        <Controller
          name="roles"
          control={form.control}
          render={({ field }) => (
            <SelectCustom
              isMulti
              placeholder={"Indifferente"}
              options={groupBy(
                roleDepartment.filter((row) => departments.includes(row.department)),
                "role"
              ).map((department) => ({
                label: department.key,
                value: department.key,
              }))}
              label="Ruoli"
              defaultValue={field.value ?? []}
              onChange={(e) => field.onChange(e)}
            />
          )}
        />
      </div>
      <div className="grid grid-cols-3 items-start gap-4 w-full">
        <div className="col-span-2">
          <AtecosSegment
            sectors={form.watch("sectors")}
            categories={form.watch("categories")}
            setSectors={e => form.setValue("sectors", e)}
            setCategories={e => form.setValue("categories", e)}
          />
        </div>
        <div className="col-span-1">
          <Controller
            name="commercialIds"
            control={form.control}
            render={({ field }) => (
              <>
                <SelectUser
                  isMulti={true}
                  filterUsers={user => user.filter(u => commercials.includes(u.id))}
                  id="select-commercials-edit-target-filters"
                  role={UserRole.commercial}
                  value={field.value ?? []}
                  onChange={(e) => field.onChange(e)}
                  label="Assegna ai commerciali"
                  placeholder={"Seleziona i commerciali"}
                  isClearable
                  error={!!form.formState.errors.commercialIds}
                  errorLabel={form.formState.errors.commercialIds?.message as string | undefined}
                />
              </>
            )}
          />
        </div>
      </div>
      <div className="flex gap-4 w-full">
        <div className="w-full">
          <ComparisonFieldRevenue
            value={form.watch("revenue")}
            onChange={e => form.setValue("revenue", e)}
            label="Fatturato"
            placeholder="Valore fatturato"
            error={!!form.formState.errors.revenue}
            errorMessage={form.formState.errors.revenue?.message as string | undefined}
          />
        </div>
      </div>
      <div className="flex gap-4 w-full">
        <div className="w-full">
          <Controller
            name="employeesNumber"
            control={form.control}
            render={({ field }) => (
              <ComparisonFieldEmployees
                value={field.value}
                onChange={field.onChange}
                label="Numero di dipendenti"
                placeholder="Valore numero di dipendenti"
                error={!!form.formState.errors.employeesNumber}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
}
